import React from 'react';
import { ChannelList, useChatContext } from 'stream-chat-react';

import './ChannelListContainer.css';

import { ChannelSearch } from '../ChannelSearch/ChannelSearch.jsx';
import { TeamChannelList } from '../TeamChannelList/TeamChannelList.jsx';
import { TeamChannelPreview } from '../TeamChannelPreview/TeamChannelPreview.jsx';
import { Accordion, Icon, Dropdown } from 'semantic-ui-react';
import useFilterPlacementSpoc from '../../../_utils/useFilterPlacementSpoc';
import { useHistory } from 'react-router-dom';

export const ChannelListContainer = (props) => {
  const { setCreateType, setIsCreating, setIsEditing, me, initialChannel } =
    props;

  const [activeIndex, setActiveIndex] = React.useState(0);
  const { setActiveChannel, client } = useChatContext();
  const history = useHistory();
  const [groupChatChannelFilter, setGroupChatChannelFilter] =
    React.useState(null);

  const { placementSpocOptions, placementSpocFilter, setPlacementSpocFilter } =
    useFilterPlacementSpoc();

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const customChannelMessagingFilter = (channels) => {
    return channels.filter((channel) => {
      return channel.data.room_type === 'group';
    });
  };
  const customChannelMessagingSingleStudentFilter = (channels) => {
    return channels.filter((channel) => {
      return channel.data.room_type !== 'group';
    });
  };
  // const customChannelMessagingStudentChatsFilter = (channels) => {
  //   return channels.filter((channel) => {
  //     return (
  //       channel.data.room_type !== 'group' && channel.data.created_by.id !== me
  //     );
  //   });
  // };

  React.useEffect(() => {
    if (placementSpocFilter.length > 0) {
      setGroupChatChannelFilter({
        members: {
          $in: placementSpocFilter,
        },
      });
    } else {
      setGroupChatChannelFilter(null);
    }
  }, [placementSpocFilter]);

  React.useEffect(() => {
    const handleEvent = (event) => {
      Notification.requestPermission().then(async (permission) => {
        if (permission === 'granted') {
          if (event?.user?.id !== client.userID) {
            const filter = { cid: event?.cid };
            const sort = [{ last_message_at: -1 }];
            const channels = await client.queryChannels(filter, sort, {
              watch: true, // this is the default
              state: true,
            });
            const channel = channels[0];
            // eslint-disable-next-line
            const newMessage = new Notification('AlmaX', {
              body: `${event?.user?.name ?? 'Someone'} says ${
                event?.message?.text ?? 'Something'
              } ${
                channel?.data?.additionalDetails?.header_title
                  ? `from ${channel?.data?.additionalDetails?.header_title}`
                  : ''
              }`,
              icon: channel?.data?.additionalDetails?.header_image ?? '',
            });
            newMessage.onclick = async () => {
              window.parent.parent.focus();
              history.push(`/job-dashboardv2/chat/${channel.id}`);
              setActiveChannel(channel);
            };
          }
        }
      });
    };
    client.on('message.new', handleEvent);

    return () => {
      client.off('message.new', handleEvent);
    };
  }, []);

  return (
    <div className='channel-list__container'>
      <div className='channel-list__list__wrapper'>
        <div className='pb-10 mb-10 border-b border-gray-400'>
          <ChannelSearch />
        </div>
        {placementSpocOptions.length > 0 && (
          <Dropdown
            placeholder='Filter By Placement Spoc'
            className='w-5/6 ml-5'
            options={placementSpocOptions}
            search
            multiple
            selection
            defaultValue={placementSpocFilter}
            onChange={(e, { value }) => {
              setPlacementSpocFilter(value);
            }}
          />
        )}
        <Accordion vertical>
          {/* Job Groups */}
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={handleClick}
          >
            <div className='grid grid-cols-12 gap-4 ml-5'>
              <div className='col-span-2'>
                <Icon size='large' name='plus square outline' color='grey' />
              </div>
              <div className='col-span-7 font-semibold text-font-para'>
                Job Groups
              </div>
              <div className='col-span-3 '>
                <Icon name='dropdown' />
              </div>
            </div>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 0}>
            <div className='overflow-auto max-h-96' style={{ width: '100%' }}>
              <ChannelList
                channelRenderFilterFn={customChannelMessagingFilter}
                // filters={groupChatChannelFilter}
                // filters={filters[0]}
                filters={groupChatChannelFilter}
                sort={{ last_message_at: -1, updated_at: -1, created_at: -1 }}
                options={{ state: true, watch: true, presence: true }}
                // options={options}
                // sort={sort}
                customActiveChannel={initialChannel?.cid ?? ''}
                List={(listProps) => (
                  <TeamChannelList
                    {...listProps}
                    {...{ setCreateType, setIsCreating, setIsEditing }}
                    type='team'
                  />
                )}
                Preview={(previewProps) => (
                  <TeamChannelPreview
                    {...previewProps}
                    {...{ setIsCreating, setIsEditing }}
                    type='team'
                    initialChannel={initialChannel}
                  />
                )}
              />
            </div>
          </Accordion.Content>
          {/* DMs */}
          <Accordion.Title
            active={activeIndex === 1}
            index={1}
            onClick={handleClick}
          >
            <div className='grid grid-cols-12 gap-4 ml-5'>
              <div className='col-span-2'>
                <Icon size='large' name='rocketchat' color='grey' />
              </div>
              <div className='col-span-7 text-base font-semibold text-font-para'>
                Direct Messages
              </div>
              <div className='col-span-3 '>
                <Icon name='dropdown' />
              </div>
            </div>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 1}>
            <div className='overflow-auto ' style={{ width: '100%' }}>
              <ChannelList
                channelRenderFilterFn={
                  customChannelMessagingSingleStudentFilter
                }
                // filters={groupChatChannelFilter}
                filters={{
                  members: {
                    $in: [`${me}`],
                  },
                  room_type: {
                    $nin: ['group'],
                  },
                  last_message_at: { $gte: '2020-01-01T00:00:00.00Z' },
                }}
                sort={{ last_message_at: -1, updated_at: -1 }}
                options={{ state: true, watch: true, presence: true }}
                // filters={filters[0]}
                // options={options}
                // sort={sort}
                customActiveChannel={initialChannel?.cid ?? ''}
                List={(listProps) => (
                  <TeamChannelList
                    {...listProps}
                    {...{ setCreateType, setIsCreating, setIsEditing }}
                    type='direct'
                  />
                )}
                Preview={(previewProps) => (
                  <TeamChannelPreview
                    {...previewProps}
                    {...{ setIsCreating, setIsEditing }}
                    type='direct'
                  />
                )}
              />
            </div>
          </Accordion.Content>
          {/* All student to student channels */}
          {/* <Accordion.Title
            active={activeIndex === 2}
            index={2}
            onClick={handleClick}
          >
            <div className='grid grid-cols-12 gap-4 ml-5'>
              <div className='col-span-2'>
                <Icon size='large' name='wechat' color='grey' />
              </div>
              <div className='col-span-7 text-base font-semibold text-font-para'>
                Student Chats
              </div>
              <div className='col-span-3 '>
                <Icon name='dropdown' />
              </div>
            </div>
          </Accordion.Title> */}
          {/* <Accordion.Content active={activeIndex === 2}>
            <div className='overflow-auto max-h-96' style={{ width: '100%' }}>
              <ChannelList
                channelRenderFilterFn={customChannelMessagingStudentChatsFilter}
                // filters={filters[0]}
                // options={options}
                // sort={sort}
                List={(listProps) => (
                  <TeamChannelList
                    {...listProps}
                    {...{ setCreateType, setIsCreating, setIsEditing }}
                    type='direct'
                  />
                )}
                Preview={(previewProps) => (
                  <TeamChannelPreview
                    {...previewProps}
                    {...{ setIsCreating, setIsEditing }}
                    type='direct'
                  />
                )}
              />
            </div>
          </Accordion.Content> */}
        </Accordion>
      </div>
    </div>
  );
};
